jQuery(document).ready(function($) {
  "use strict";

  if ($(".tf-sw-recent").length > 0) {
    var preview = $(".tf-sw-recent").data("preview");
    var tablet = $(".tf-sw-recent").data("tablet");
    var mobile = $(".tf-sw-recent").data("mobile");
    var spacingLg = $(".tf-sw-recent").data("space-lg");
    var spacingMd = $(".tf-sw-recent").data("space-md");
    var spacing = $(".tf-sw-recent").data("space");
    var perGroup = $(".tf-sw-recent").data("pagination") || 4;
    var perGroupMd = $(".tf-sw-recent").data("pagination-md") || 3;
    var perGroupLg = $(".tf-sw-recent").data("pagination-lg") || 2;
    var swiper = new Swiper(".tf-sw-recent", {
        slidesPerView: mobile,
        spaceBetween: spacing,
        pagination: {
            el: ".sw-pagination-recent",
            clickable: true,
        },
        slidesPerGroup: perGroup,
        observer: true,
        observeParents: true,
        speed: 1000,
        navigation: {
            clickable: true,
            nextEl: ".nav-prev-recent",
            prevEl: ".nav-next-recent",
        },
        breakpoints: {
            768: {
                slidesPerView: tablet,
                spaceBetween: spacingMd,
                slidesPerGroup: perGroupMd,
            },
            1200: {
                slidesPerView: preview,
                spaceBetween: spacingLg,
                slidesPerGroup: perGroupLg,
            },
        },
    });
}

    if ($(".tf-sw-latest").length > 0) {
        var preview = $(".tf-sw-latest").data("preview");
        var tablet = $(".tf-sw-latest").data("tablet");
        var mobile = $(".tf-sw-latest").data("mobile");
        var spacingLg = $(".tf-sw-latest").data("space-lg");
        var spacingMd = $(".tf-sw-latest").data("space-md");
        var spacing = $(".tf-sw-latest").data("space");
        var perGroup = $(".tf-sw-latest").data("pagination") || 4;
        var perGroupMd = $(".tf-sw-latest").data("pagination-md") || 3;
        var perGroupLg = $(".tf-sw-latest").data("pagination-lg") || 2;
        var swiper = new Swiper(".tf-sw-latest", {
            slidesPerView: mobile,
            spaceBetween: spacing,
            observer: true,
            observeParents: true,
            speed: 1000,
            pagination: {
                el: ".sw-pagination-latest",
                clickable: true,
            },
            slidesPerGroup: perGroup,
            navigation: {
                clickable: true,
                nextEl: ".nav-prev-latest",
                prevEl: ".nav-next-latest",
            },
            breakpoints: {
                768: {
                    slidesPerView: tablet,
                    spaceBetween: spacingMd,
                    slidesPerGroup: perGroupMd,
                },
                1200: {
                    slidesPerView: preview,
                    spaceBetween: spacingLg,
                    slidesPerGroup: perGroupLg,
                },
            },
        });
    }

  $(".widget-tabs").each(function() {
    $(this)
      .find(".widget-menu-tab")
      .children(".item-title")
      .on("click", function() {
        var liActive = $(this).index();
        var contentActive = $(this)
          .siblings()
          .removeClass("active")
          .parents(".widget-tabs")
          .find(".widget-content-tab")
          .children()
          .eq(liActive);
        contentActive.addClass("active").fadeIn("slow");
        contentActive.siblings().removeClass("active");
        $(this)
          .addClass("active")
          .parents(".widget-tabs")
          .find(".widget-content-tab")
          .children()
          .eq(liActive);
      });
  });

  function compare() {
    $('#recentlyViewed .swiper-wrapper .compare').each(function() {
      $(this).off('click').on('click', function () {
        const $card = $(this).closest('.card-product');
        const productId = $card.find('.colorItem.active').data('id') || $card.data('productid');
        const img = $card.find('.colorItem.active').data('img') || $card.find('.image-wrap img:first').attr('src');
        const url = $card.find('.image-wrap').attr('href') + (productId ? `?variant=${productId}` : '');

        if (!productId) return;

        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (!dataUser.randomId) {
          dataUser = {
            id: typeof customerId !== "undefined" ? customerId : "",
            randomId: themeName + products.generateRandomString(100),
            dataWishlist: [],
            dataCompare: []
          };
        }

        const exists = dataUser.dataCompare?.some(item => item.id == productId);

        if (exists) {
          dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
          $(`.tf-sidebar-compare .item[data-id="${productId}"]`).remove();
          $card.removeClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;
        } else {
          dataUser.dataCompare = [...(dataUser.dataCompare || []), { id: productId, img, url }];
          $('.tf-sidebar-compare .content').append(`
            <div class="item" data-id="${productId}">
              <span class="remove">
                <span class="icon icon-close"></span>
              </span>
              <a href="${url}" title=""><img src="${img}" alt=""></a>
            </div>`);
          $card.addClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip-delete');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          $('.tf-sidebar-compare').addClass('active');;
        }

        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        S00801SidebarCompare.init();
      });
    });
  }

  function clickColors() {
    $('#recentlyViewed .swiper-wrapper .colorItem').each(function () {
      $(this).off('click').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
        var _i = $(this).data('index');
        $('#recentlyViewed .swiper-wrapper .cartProduct__prices .price').eq(_i).addClass('active').siblings().removeClass('active');
      });
    });
  }

  // Load recently viewed products
  function loadRecentlyViewed() {
    const dataUserStr = localStorage.getItem('dataUser');

    if (!dataUserStr) {
      console.warn("No dataUser found in localStorage");
      return;
    }

    let dataUser;
    try {
      dataUser = JSON.parse(dataUserStr);
    } catch (e) {
      console.error("Error parsing dataUser from localStorage:", e);
      return;
    }

    const userId = dataUser?.randomId;
    if (!userId) {
      console.warn("Missing randomId in dataUser");
      return;
    }


    fetch(`${linkApp}/products-recent?user_id=${userId}&domain_name=${domain}`)
      .then(res => res.json())
      .then(data => {
        const totalItems = data.data.length;
        if (!Array.isArray(data.data) || totalItems === 0 ) {
              $('#recentlyViewed .loading-wrapper').hide();
               $('#recentlyViewed .swiper-wrapper').append('<p class="no-products">No Produts.</p>');
            return;
        }

        $.each(data.data, function(index, item) {
          // if (index >= 8) return false;
          const handle = item.handle;
          const url = `/products/${handle}?view=handle`;

          $.get(url, function(productData) {
            const doc = new DOMParser().parseFromString(productData, 'text/html');
            const itemHtml = doc.querySelector('.card-product-handle');

             if (itemHtml) {
                const desc = itemHtml.querySelector('.cartProduct__desc');
                const btncart = itemHtml.querySelector('.box-icon.addcart');

                if (desc) desc.remove();
                if (btncart) btncart.remove();

                const swiperSlide = document.createElement('div');
                swiperSlide.classList.add('swiper-slide');

                swiperSlide.appendChild(itemHtml);

                // $('#recentlyViewed .swiper-wrapper').empty(); 
                $('#recentlyViewed .swiper-wrapper').append(swiperSlide); 
               
                $('#recentlyViewed .loading-wrapper').hide();

                events(); // Bind events once all products are rendered  
            }
          });
        });
      })
      .catch(err => {
                console.error("Error calling recent views API:", err);
                const container = $('#recentlyViewed .swiper-wrapper');
                container.find('.loading').hide();
                container.append('<p class="no-products">Error API</p>');
            });

  }



  // Rebind product interaction events
  function events() {
    clickColors();
    addcart();
    compare();
    S00601CartProduct.wishlist();
    S00601CartProduct.quickView();
    products.init();
  }

  function addcart() {
    $(' #recentlyViewed .swiper-wrapper .btn-add-cart, #relatedProducts .swiper-wrapper .btn-add-cart').each(function() {
      $(this).off('click').on('click', function () {
        var variantId = $(this).parents('.card-product').find('.colorItem.active').data('id');
        const quantity = 1;
        if (variantId == undefined)
          variantId = $(this).parents('.card-product').data('productid');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: quantity,
            id: variantId
          },
          dataType: 'json',
          success: function() {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                $('.nav-cart .icon-cart').next().remove();
                $('.nav-cart .icon-cart').after('<span class="count-box text-button-small">'+cart.item_count+'</span>');
                $('.open-cart').trigger('click'); 
                setTimeout(function() {
                  $('.tf-minicart-recommendations').addClass('open');
                }, 800);
              });
          },
          error: function(err) {
            alert('Add to cart failed.');
            console.error(err);
          }
        });
      });
    });
  }

  function compare() {
    $('#recentlyViewed .swiper-wrapper .compare,#relatedProducts .swiper-wrapper .compare').each(function() {
      $(this).off('click').on('click', function () {
        const $card = $(this).closest('.card-product');
        const productId = $card.find('.colorItem.active').data('id') || $card.data('productid');
        const img = $card.find('.colorItem.active').data('img') || $card.find('.image-wrap img:first').attr('src');
        const url = $card.find('.image-wrap').attr('href') + (productId ? `?variant=${productId}` : '');

        if (!productId) return;

        let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

        if (!dataUser.randomId) {
          dataUser = {
            id: typeof customerId !== "undefined" ? customerId : "",
            randomId: themeName + products.generateRandomString(100),
            dataWishlist: [],
            dataCompare: []
          };
        }

        const exists = dataUser.dataCompare?.some(item => item.id == productId);

        if (exists) {
          dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
          $(`.tf-sidebar-compare .item[data-id="${productId}"]`).remove();
          $card.removeClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;
        } else {
          dataUser.dataCompare = [...(dataUser.dataCompare || []), { id: productId, img, url }];
          $('.tf-sidebar-compare .content').append(`
            <div class="item" data-id="${productId}">
              <span class="remove">
                <span class="icon icon-close"></span>
              </span>
              <a href="${url}" title=""><img src="${img}" alt=""></a>
            </div>`);
          $card.addClass('compared');
          $card.find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
          var tooltipDelete = $card.find('.box-icon.compare').data('tooltip-delete');
          $card.find('.box-icon.compare .tooltip').text(tooltipDelete);
          $('.tf-sidebar-compare').addClass('active');;
        }

        localStorage.setItem("dataUser", JSON.stringify(dataUser));
        S00801SidebarCompare.init();
      });
    });
  }

  function clickColors() {
    $('#recentlyViewed .swiper-wrapper .colorItem').each(function () {
      $(this).off('click').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
        var _i = $(this).data('index');
        $('#recentlyViewed .swiper-wrapper .cartProduct__prices .price').eq(_i).addClass('active').siblings().removeClass('active');
      });
    });

    $('#relatedProducts .swiper-wrapper .colorItem').each(function () {
      $(this).off('click').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
        var _i = $(this).data('index');
        $('#relatedProducts .swiper-wrapper .cartProduct__prices .price').eq(_i).addClass('active').siblings().removeClass('active');
      });
    });
  }

  loadRecentlyViewed();

  function loadRelatedProduct() {
    if($('#relatedProducts .swiper-wrapper').length > 0 ) {

      const dataUserStr = localStorage.getItem('dataUser');
      if (!dataUserStr) {
        console.warn("No dataUser found in localStorage");
        return;
      }

      let dataUser;
      try {
        dataUser = JSON.parse(dataUserStr);
      } catch (e) {
        console.error("Error parsing dataUser from localStorage:", e);
        return;
      }

      const userId = dataUser?.randomId;
      if (!userId) {
        console.warn("Missing randomId in dataUser");
        return;
      }

      var cId = $('#relatedProducts .swiper-wrapper').data('collection_id');

      fetch(`${linkApp}/products-related?domain_name=${domain}&collection_id=${cId}`)
      .then(res => res.json())
      .then(response => {
        if (response.status === 'success') {
          const data = response.data;
          $('#relatedProducts .swiper-wrapper').empty();

          $.each(data, function(index, item) {
            const handle = item.handle;
            const url = `/products/${handle}?view=handle`;

            $.ajax({
              url: url,
              type: 'GET',
              success: function(productData) {
                const doc = new DOMParser().parseFromString(productData, 'text/html');
                
                const itemHtml = doc.querySelector('.card-product-handle');

                // if (itemHtml) {
                //   $('.renderRelatedProduct_wrap').append(itemHtml.outerHTML);
                // }

                if (itemHtml) {
                  const desc = itemHtml.querySelector('.cartProduct__desc');
                  const btncart = itemHtml.querySelector('.box-icon.addcart');

                  if (desc) desc.remove();
                  if (btncart) btncart.remove();

                  const swiperSlide = document.createElement('div');
                  swiperSlide.classList.add('swiper-slide');

                  swiperSlide.appendChild(itemHtml);

                  // $('#recentlyViewed .swiper-wrapper').empty(); 
                  $('#relatedProducts .swiper-wrapper').append(swiperSlide); 
                
                  $('#relatedProducts .loading-wrapper').hide();

                  events(); // Bind events once all products are rendered  
              }

              },
              error: function() {
                console.warn("Error loading:", handle);
              },
              
            });
          });
        } else {
          console.error('API return error:', response);
        }
      })
      .catch(err => {
        console.error("Error calling recent views API:", err);
      });
    }
  }

  loadRelatedProduct();
});